import type { QuizItem } from '@/types/quiz'

export const pickRandomUnsolved = (quizzes: QuizItem[]): QuizItem | null => {
  const unsolvedMap = new Map(
    quizzes.filter((quiz) => !quiz.isSolved).map((quiz) => [quiz.id, quiz])
  )
  if (unsolvedMap.size === 0) return null

  const ids = [...unsolvedMap.keys()]
  const randomId = ids[Math.floor(Math.random() * ids.length)]
  return unsolvedMap.get(randomId) ?? null
}
